// src/components/picker/picker.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment CurrencySelectorFragment on CurrencySelector {\n    disabled\n    heading\n    queryParameterName\n    options {\n      name\n      selected\n      value\n    }\n    onChangeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment LanguageSelectorFragment on LanguageSelector {\n    heading\n    queryParameterName\n    options {\n      name\n      selected\n      value\n    }\n    onChangeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment PosSelectorFragment on PosSelector {\n    heading\n    options {\n      name\n      selected\n      value\n    }\n    onChangeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment OneKeyMessagingFragment on Picker {\n    oneKeyMessagingHeading\n    oneKeyMessagingSubHeading\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  query LocalePreferencesQuery(\n    $context: ContextInput!\n    $lineOfBusiness: GlobalNavigationLineOfBusiness\n    $pickerTriggerPlacementType: PickerTriggerPlacementType\n    $selectedSiteId: Int\n  ) {\n    localePreferences(\n      context: $context\n      lineOfBusiness: $lineOfBusiness\n      pickerTriggerPlacementType: $pickerTriggerPlacementType\n      selectedSiteId: $selectedSiteId\n    ) {\n      heading\n      closeDialogText\n      submitText\n      bannerText\n      ...OneKeyMessagingFragment\n      urlToSubmit\n      queryParamsToSubmit {\n        key\n        value\n      }\n      trigger {\n        iconName\n        text\n        flagName\n        trackingEvent\n        displayType\n      }\n      preferences {\n        __typename\n        ...CurrencySelectorFragment\n        ...LanguageSelectorFragment\n        ...PosSelectorFragment\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      saveAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React5 from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import * as queryString from "query-string";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSButtonSize, EGDSFloatingFullWidthButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSMarkFlag } from "@egds/react-core/mark";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/__generated__/types.ts
var GlobalNavigationLineOfBusiness = /* @__PURE__ */ function(GlobalNavigationLineOfBusiness3) {
    GlobalNavigationLineOfBusiness3["ACTIVITY"] = "ACTIVITY";
    GlobalNavigationLineOfBusiness3["CAR"] = "CAR";
    GlobalNavigationLineOfBusiness3["CRUISE"] = "CRUISE";
    GlobalNavigationLineOfBusiness3["FLIGHT"] = "FLIGHT";
    GlobalNavigationLineOfBusiness3["HOTEL"] = "HOTEL";
    GlobalNavigationLineOfBusiness3["PACKAGE"] = "PACKAGE";
    GlobalNavigationLineOfBusiness3["UNKNOWN"] = "UNKNOWN";
    return GlobalNavigationLineOfBusiness3;
}(GlobalNavigationLineOfBusiness || {});
var PickerTriggerPlacementType = /* @__PURE__ */ function(PickerTriggerPlacementType3) {
    PickerTriggerPlacementType3["MENU_ITEM"] = "MENU_ITEM";
    PickerTriggerPlacementType3["NAV_LINK"] = "NAV_LINK";
    return PickerTriggerPlacementType3;
}(PickerTriggerPlacementType || {});
// src/components/picker/__private/__fragments/currency-selector.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// src/utils/analytics.ts
var regexToReplaceBraces = /\{value\}/g;
var replaceValueReferrerId = function(referrerId, value) {
    var noSpaceValue = value.replace(/\s/, "");
    return referrerId.replace(regexToReplaceBraces, noSpaceValue);
};
// src/components/picker/__private/__fragments/currency-selector.tsx
var fragment = gql(_templateObject());
var CurrencySelector = function(props) {
    var data = props.data, updateQueryParams = props.updateQueryParams;
    var disabled = data.disabled, heading = data.heading, queryParameterName = data.queryParameterName, options = data.options, onChangeAnalytics = data.onChangeAnalytics;
    var initiallySelectedOption = options.find(function(option) {
        return option.selected === true;
    });
    var _React_useState = _sliced_to_array(React.useState((initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || ""), 2), value = _React_useState[0], setValue = _React_useState[1];
    var trackClick = useClickTracker();
    React.useEffect(function() {
        return setValue((initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || "");
    }, [
        initiallySelectedOption
    ]);
    var handleChange = function(event) {
        var nextValue = event.target.value;
        var referrerId = (onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId) ? replaceValueReferrerId(onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId, nextValue) : "";
        var _onChangeAnalytics_linkName;
        trackClick(referrerId, (_onChangeAnalytics_linkName = onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.linkName) !== null && _onChangeAnalytics_linkName !== void 0 ? _onChangeAnalytics_linkName : "");
        setValue(nextValue);
        updateQueryParams(queryParameterName, nextValue, (initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || null);
    };
    if (!options.length) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(EGDSSelect, {
        id: "currency-selector",
        label: heading,
        value: value,
        onChange: handleChange,
        disabled: disabled
    }, options.map(function(option) {
        return /* @__PURE__ */ React.createElement("option", {
            key: option.value,
            value: option.value
        }, option.name);
    }));
};
CurrencySelector.displayName = "CurrencySelector";
CurrencySelector.fragment = _object_spread_props(_object_spread({}, fragment), {
    __typename: "CurrencySelector"
});
// src/components/picker/__private/__fragments/language-selector.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSSelect as EGDSSelect2 } from "@egds/react-core/input";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment2 = gql2(_templateObject1());
var LanguageSelector = function(props) {
    var data = props.data, updateQueryParams = props.updateQueryParams;
    var heading = data.heading, options = data.options, queryParameterName = data.queryParameterName, onChangeAnalytics = data.onChangeAnalytics;
    var initiallySelectedOption = options.find(function(option) {
        return option.selected === true;
    });
    var _React2_useState = _sliced_to_array(React2.useState((initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || ""), 2), value = _React2_useState[0], setValue = _React2_useState[1];
    var trackClick = useClickTracker2();
    React2.useEffect(function() {
        return setValue((initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || "");
    }, [
        initiallySelectedOption
    ]);
    var handleChange = function(event) {
        var selectedIndex = event.target.options.selectedIndex;
        var name = options[selectedIndex].name;
        var referrerId = (onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId) ? replaceValueReferrerId(onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId, name) : "";
        var _onChangeAnalytics_linkName;
        trackClick(referrerId, (_onChangeAnalytics_linkName = onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.linkName) !== null && _onChangeAnalytics_linkName !== void 0 ? _onChangeAnalytics_linkName : "");
        var nextValue = event.target.value;
        setValue(nextValue);
        updateQueryParams(queryParameterName, nextValue, (initiallySelectedOption === null || initiallySelectedOption === void 0 ? void 0 : initiallySelectedOption.value) || null);
    };
    if (!options.length) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(EGDSSelect2, {
        id: "language-selector",
        label: heading,
        value: value,
        onChange: handleChange
    }, options.map(function(option) {
        return /* @__PURE__ */ React2.createElement("option", {
            key: option.value,
            value: option.value
        }, option.name);
    }));
};
LanguageSelector.displayName = "LanguageSelector";
LanguageSelector.fragment = _object_spread_props(_object_spread({}, fragment2), {
    __typename: "LanguageSelector"
});
// src/components/picker/__private/__fragments/pos-selector.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSSelect as EGDSSelect3 } from "@egds/react-core/input";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment3 = gql3(_templateObject2());
var PosSelector = function(props) {
    var refetch = props.refetch, data = props.data;
    var heading = data.heading, options = data.options, onChangeAnalytics = data.onChangeAnalytics;
    var initallySelectedOption = options.find(function(option) {
        return option.selected === true;
    });
    var _React3_useState = _sliced_to_array(React3.useState((initallySelectedOption === null || initallySelectedOption === void 0 ? void 0 : initallySelectedOption.value) || ""), 2), value = _React3_useState[0], setValue = _React3_useState[1];
    var trackClick = useClickTracker3();
    var handlePosChange = function(event) {
        var selectedIndex = event.target.options.selectedIndex;
        var name = options[selectedIndex].name;
        var referrerId = (onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId) ? replaceValueReferrerId(onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.referrerId, name) : "";
        var _onChangeAnalytics_linkName;
        trackClick(referrerId, (_onChangeAnalytics_linkName = onChangeAnalytics === null || onChangeAnalytics === void 0 ? void 0 : onChangeAnalytics.linkName) !== null && _onChangeAnalytics_linkName !== void 0 ? _onChangeAnalytics_linkName : "");
        var selectedSiteId = event.target.value;
        setValue(selectedSiteId);
        refetch({
            selectedSiteId: Number(selectedSiteId)
        });
    };
    if (!options.length) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(EGDSSelect3, {
        id: "site-selector",
        "data-stid": "site-selector",
        label: heading,
        value: value,
        onChange: handlePosChange
    }, options.map(function(option) {
        return /* @__PURE__ */ React3.createElement("option", {
            key: option.value,
            value: option.value
        }, option.name);
    }));
};
PosSelector.displayName = "PosSelector";
PosSelector.fragment = _object_spread_props(_object_spread({}, fragment3), {
    __typename: "PosSelector"
});
// src/components/picker/__private/__fragments/one-key-messaging.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
var fragment4 = gql4(_templateObject3());
var OneKeyMessaging = function(param) {
    var data = param.data;
    var oneKeyMessagingHeading = data.oneKeyMessagingHeading, oneKeyMessagingSubHeading = data.oneKeyMessagingSubHeading;
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, oneKeyMessagingHeading && /* @__PURE__ */ React4.createElement(EGDSSpacing, {
        padding: {
            inline: "four",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React4.createElement(EGDSLayoutFlex, null, /* @__PURE__ */ React4.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React4.createElement(EGDSSpacing, {
        margin: {
            inlinestart: "two",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React4.createElement(EGDSIcon, {
        name: "warning"
    }))), /* @__PURE__ */ React4.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React4.createElement("div", {
        "data-stid": "picker-one-key-heading"
    }, /* @__PURE__ */ React4.createElement(EGDSHeading, {
        size: 6
    }, oneKeyMessagingHeading))))), oneKeyMessagingSubHeading && /* @__PURE__ */ React4.createElement(EGDSSpacing, {
        padding: {
            inline: "six",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React4.createElement("div", {
        "data-stid": "picker-one-key-subheading"
    }, /* @__PURE__ */ React4.createElement(EGDSText, {
        size: 400
    }, oneKeyMessagingSubHeading))));
};
OneKeyMessaging.displayName = "OneKeyMessaging";
OneKeyMessaging.fragment = fragment4;
// src/components/picker/picker.tsx
var __PickerQuery = gql5(_templateObject4(), CurrencySelector.fragment, LanguageSelector.fragment, PosSelector.fragment, OneKeyMessaging.fragment);
var selectorTypes = [
    CurrencySelector,
    LanguageSelector,
    PosSelector
];
var PickerBannerText = function(param) {
    var content = param.content;
    return /* @__PURE__ */ React5.createElement(EGDSBanner, {
        fullWidth: true
    }, /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlex2, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        margin: {
            inlinestart: "four",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        name: "info_outline"
    }))), /* @__PURE__ */ React5.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React5.createElement("div", {
        "data-stid": "picker-banner-text"
    }, /* @__PURE__ */ React5.createElement(EGDSText2, null, content))))));
};
var Picker = function(props) {
    var skipSsr = props.skipSsr, lineOfBusiness = props.lineOfBusiness, pickerTriggerPlacementType = props.pickerTriggerPlacementType, inverseTheme = props.inverseTheme;
    var context = useBexApi().context;
    var variables = {
        context: context,
        lineOfBusiness: lineOfBusiness,
        pickerTriggerPlacementType: pickerTriggerPlacementType
    };
    var _useQuery = useQuery(__PickerQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, refetch = _useQuery.refetch, networkStatus = _useQuery.networkStatus;
    var _useDialog = _sliced_to_array(useDialog("disp-settings-picker"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var triggerRef = React5.useRef(null);
    var trackClick = useClickTracker4();
    var omitNavButtonClass = useExperiment("Shared_UI_Remove_Deprecated_UITK_Nav_Button").exposure.bucket > 0;
    var handlePickerToolbarClick = React5.useCallback(function() {
        dialogActions.closeDialog();
    }, [
        dialogActions
    ]);
    var queryParams = {};
    var updateQueryParams = function(queryParameterName, newValue, initialValue) {
        if (newValue === initialValue) {
            delete queryParams[queryParameterName];
        } else {
            queryParams[queryParameterName] = newValue;
        }
    };
    var handleSubmit = function() {
        var _data_localePreferences, _data_localePreferences1, _data_localePreferences2;
        dialogActions.closeDialog();
        var saveAnalytics = data === null || data === void 0 ? void 0 : (_data_localePreferences = data.localePreferences) === null || _data_localePreferences === void 0 ? void 0 : _data_localePreferences.saveAnalytics;
        if (saveAnalytics === null || saveAnalytics === void 0 ? void 0 : saveAnalytics.referrerId) {
            trackClick(saveAnalytics.referrerId, (saveAnalytics === null || saveAnalytics === void 0 ? void 0 : saveAnalytics.linkName) || "Picker button");
        }
        var urlToSubmit = data === null || data === void 0 ? void 0 : (_data_localePreferences1 = data.localePreferences) === null || _data_localePreferences1 === void 0 ? void 0 : _data_localePreferences1.urlToSubmit;
        var queryParamsToSubmit = (data === null || data === void 0 ? void 0 : (_data_localePreferences2 = data.localePreferences) === null || _data_localePreferences2 === void 0 ? void 0 : _data_localePreferences2.queryParamsToSubmit) || [];
        var formattedQueryParamsToSubmit = {};
        queryParamsToSubmit.forEach(function(serverQueryParam) {
            formattedQueryParamsToSubmit[serverQueryParam.key] = serverQueryParam.value;
        });
        var serverQueryParamsHaveChanges = Object.keys(queryParamsToSubmit).length > 0;
        var clientQueryParamsHaveChanges = Object.keys(queryParams).length > 0;
        if (urlToSubmit || serverQueryParamsHaveChanges || clientQueryParamsHaveChanges) {
            if (urlToSubmit) {
                var mergedQueryParams = queryString.stringify(_object_spread({}, formattedQueryParamsToSubmit, queryParams));
                window.location.href = mergedQueryParams ? "".concat(urlToSubmit, "?").concat(mergedQueryParams) : urlToSubmit;
            } else {
                var currentParamsParsed = queryString.parse(window.location.search);
                var mergedQueryParams1 = queryString.stringify(_object_spread({}, currentParamsParsed, formattedQueryParamsToSubmit, queryParams));
                window.location.search = mergedQueryParams1;
            }
        }
    };
    var isRefetching = networkStatus === 2 || networkStatus === 4;
    if (loading && !isRefetching || error || !data) {
        return null;
    }
    var localePreferences = data.localePreferences;
    var preferences = localePreferences.preferences, trigger = localePreferences.trigger, heading = localePreferences.heading, closeDialogText = localePreferences.closeDialogText, submitText = localePreferences.submitText, bannerText = localePreferences.bannerText, impressionAnalytics = localePreferences.impressionAnalytics;
    if (!preferences || !preferences.length) {
        return null;
    }
    var triggerOnClick = function() {
        trackClick(trigger.trackingEvent, "");
        dialogActions.toggleDialog();
    };
    var triggerContentNull = /* @__PURE__ */ React5.createElement(React5.Fragment, null, trigger.iconName && /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        name: trigger.iconName,
        size: EGDSIconSize.SMALL
    })), /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        margin: {
            inline: "one"
        }
    }, /* @__PURE__ */ React5.createElement("span", null, trigger.text)), trigger.flagName && /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSMarkFlag, {
        id: trigger.flagName,
        name: trigger.flagName,
        title: trigger.flagName,
        description: trigger.flagName
    })));
    var triggerContent = /* @__PURE__ */ React5.createElement(React5.Fragment, null, trigger.iconName && /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        id: trigger.iconName,
        name: trigger.iconName,
        size: EGDSIconSize.SMALL,
        title: trigger.iconName,
        description: trigger.iconName
    })), trigger.text, trigger.flagName && /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        padding: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSMarkFlag, {
        name: trigger.flagName
    })));
    var triggerContentMenu = /* @__PURE__ */ React5.createElement(React5.Fragment, null, trigger.iconName && /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        name: trigger.iconName,
        size: EGDSIconSize.SMALL
    }), trigger.text, trigger.flagName && /* @__PURE__ */ React5.createElement(EGDSMarkFlag, {
        name: trigger.flagName
    }));
    var dialogComponentContent = /* @__PURE__ */ React5.createElement(EGDSSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React5.createElement(DialogComponent, null, /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewSmall, null, /* @__PURE__ */ React5.createElement(EGDSSheet, {
        isVisible: isDialogOpen,
        returnFocusOnClose: true,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React5.createElement(EGDSToolbar, {
        toolbarTitle: heading,
        key: "picker-dialog-toolbar",
        navigationContent: {
            onClick: handlePickerToolbarClick,
            navIconLabel: closeDialogText,
            navType: "close"
        }
    }), bannerText && /* @__PURE__ */ React5.createElement(PickerBannerText, {
        content: bannerText
    }), /* @__PURE__ */ React5.createElement(OneKeyMessaging, {
        data: data.localePreferences
    }), /* @__PURE__ */ React5.createElement(EGDSSheetContent, null, preferences.map(function(selector) {
        if (!selector) {
            return null;
        }
        var Selector = selectorTypes.find(function(type) {
            return type.fragment.__typename === selector.__typename;
        });
        if (!Selector) {
            return null;
        }
        return /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
            margin: {
                block: "three"
            },
            key: "selector-".concat(selector.__typename)
        }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(Selector, {
            refetch: refetch,
            data: selector,
            updateQueryParams: updateQueryParams
        })));
    }), /* @__PURE__ */ React5.createElement(EGDSScrim, {
        type: EGDSScrimType.BUTTON
    }, /* @__PURE__ */ React5.createElement(EGDSFloatingFullWidthButton, {
        isFullWidth: true,
        size: EGDSButtonSize.LARGE,
        onClick: handleSubmit
    }, submitText))))), /* @__PURE__ */ React5.createElement(ViewLarge, null, /* @__PURE__ */ React5.createElement(EGDSSheet, {
        isVisible: isDialogOpen,
        returnFocusOnClose: true,
        type: "centered",
        centeredSheetSize: "small",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React5.createElement(EGDSToolbar, {
        toolbarTitle: heading,
        key: "picker-dialog-toolbar",
        navigationContent: {
            onClick: handlePickerToolbarClick,
            navIconLabel: closeDialogText,
            navType: "close"
        }
    }), bannerText && /* @__PURE__ */ React5.createElement(PickerBannerText, {
        content: bannerText
    }), /* @__PURE__ */ React5.createElement(OneKeyMessaging, {
        data: data.localePreferences
    }), /* @__PURE__ */ React5.createElement(EGDSSheetContent, null, preferences.map(function(selector) {
        if (!selector) {
            return null;
        }
        var Selector = selectorTypes.find(function(type) {
            return type.fragment.__typename === selector.__typename;
        });
        if (!Selector) {
            return null;
        }
        return /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
            margin: {
                block: "three"
            },
            key: "selector-".concat(selector.__typename)
        }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(Selector, {
            refetch: refetch,
            data: selector,
            updateQueryParams: updateQueryParams
        })));
    }), /* @__PURE__ */ React5.createElement(EGDSFloatingFullWidthButton, {
        isFullWidth: true,
        size: EGDSButtonSize.LARGE,
        onClick: handleSubmit
    }, submitText)))))));
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, trigger.displayType === "GLOBAL_NAV_LINK" /* GLOBAL_NAV_LINK */  ? /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React5.createElement(EGDSLink, {
        className: "uitk-list-item",
        onClick: triggerOnClick,
        "data-stid": "link-type-picker-trigger",
        domRef: triggerRef
    }, /* @__PURE__ */ React5.createElement("button", {
        type: "button"
    }, triggerContentMenu))) : /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        margin: omitNavButtonClass ? {
            small: {
                inline: "one"
            },
            large: {
                inline: "two"
            }
        } : void 0
    }, /* @__PURE__ */ React5.createElement(EGDSTertiaryButton, {
        className: omitNavButtonClass ? void 0 : "global-navigation-nav-button",
        onClick: triggerOnClick,
        "data-stid": "button-type-picker-trigger",
        domRef: triggerRef,
        inverse: inverseTheme
    }, trigger.iconName === null ? triggerContentNull : triggerContent)), isDialogOpen && ((impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) ? /* @__PURE__ */ React5.createElement(IntersectionTracker, {
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, dialogComponentContent) : dialogComponentContent));
};
Picker.displayName = "sharedui-Picker";
export { GlobalNavigationLineOfBusiness, Picker, PickerTriggerPlacementType };
//# sourceMappingURL=index.js.map